import { InspectionListType } from '@/api'

export interface CreateInspectionListRequest {
  id: number
  listType: InspectionListType
}
export function CreateInspectionListRequestToJSON(
  value: CreateInspectionListRequest
): any {
  return {
    id: value.id !== 0 ? value.id : undefined,
    list_type:
      value.listType !== InspectionListType.UnSelected
        ? value.listType
        : undefined
  }
}
